import styles from "./shift-records-details-stock-inventory-wet/shift-details-stock-inventory-dipstick.module.scss";
import grid from "styles/grid.module.scss";
import { InputAmount } from "components/field";
import { Text } from "components/commons";

const DipstickInput = ({
  unit,
  placeholder,
  fields,
  modifyField,
  disabled,
  beginning = false,
  decimalPlaces = 4,
}) => (
  <>
    <div>
      <div className={grid.row}>
        <div className={styles.columnFluid}>
          <InputAmount
            {...fields}
            decimalPlaces={decimalPlaces}
            innerLabel={false}
            className={styles.textfield}
            placeholder={placeholder}
            onChange={modifyField}
            disabled={disabled}
            inputDisabled={disabled}
            helperText={fields?.message || ""}
          />
        </div>
        <div className={styles.columnFluid}>
          <div className={styles.unit}>
            <div className={styles.text}>{unit}</div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export const DipstickInputV2 = ({
  unit,
  placeholder,
  fields,
  modifyField,
  disabled,
  className,
  classNameInput,
  classNameMessage,
  decimalPlaces = 4,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className={`${grid.row} ${className}`}>
          <div className={styles.columnFluid}>
            <InputAmount
              {...fields}
              decimalPlaces={decimalPlaces}
              innerLabel={false}
              className={`${styles.textfield} ${classNameInput}`}
              placeholder={placeholder}
              onChange={modifyField}
              disabled={disabled}
              inputDisabled={disabled}
            />
          </div>
          <div className={styles.columnFluid}>
            <div className={styles.unit}>
              <div className={styles.text}>{unit}</div>
            </div>
          </div>
        </div>
        <div className={classNameMessage}>
          <Text subtitle color={"#f44336"}>
            {fields?.message || ""}
          </Text>
        </div>
      </div>
    </>
  );
};

export default DipstickInput;
